module.exports = __webpack_public_path__ + "img/dotted-loading.851fcc7b.gif";